import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentNextActionPillId } from './useTrackAgentNextActionPillClicked.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export {
  WORKSPACE_AGENT_NEXT_ACTION_PILL_IDS,
  type WorkspaceAgentNextActionPillId,
} from './useTrackAgentNextActionPillClicked.meta';

export type UseTrackAgentNextActionPillClickedParams = {
  pill_id: WorkspaceAgentNextActionPillId;
};

export const useTrackAgentNextActionPillClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentNextActionPillClicked = useCallback(
    (params: UseTrackAgentNextActionPillClickedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentNextActionPillClicked };
};
